import styled from 'styled-components';
import { DisplayContainer } from './Common.styled';

// News Container Display - extends DisplayContainer with news-specific styling
export const NewsContainerDisplay = styled(DisplayContainer)`
  position: relative;
  // margin: 20px auto;
  overflow: hidden;
  width: 1200px;
  height: 575px;
  max-width: 90%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  padding: 40px;
  
  /*  Glassmorphism Styling - Optimized for TV */
  background: ${(props) => props.theme.colors.glassBackground};
  backdrop-filter: ${(props) => props.theme.effects.backdropBlurLight};
  border: 1px solid ${(props) => props.theme.colors.glassOverlay};
  border-radius: ${(props) => props.theme.effects.borderRadiusLarge};
  color: ${(props) => props.theme.colors.textPrimary};
  transition: ${(props) => props.theme.effects.transitionMedium}; /* Simplified for TV */
  will-change: transform;
  
  /* Glow Effect - REMOVED for TV performance */
  /* &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: ${(props) => props.theme.colors?.glowGradient || 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent)'};
    border-radius: ${(props) => props.theme.effects?.borderRadiusLarge || '24px'} ${(props) => props.theme.effects?.borderRadiusLarge || '24px'} 0 0;
    animation: shimmer 3s ease-in-out infinite;
  }
  
  @keyframes shimmer {
    0%, 100% { transform: translateX(-100%); }
    50% { transform: translateX(100%); }
  } */
  
  /* Hover Effects */
  &:hover {
    transform: translateY(-2px); /* Reduced from -5px for better performance */
  }
  
  /* News Item Styling */
  > div {
    width: 100%;
    padding: 25px;
    margin-bottom: 20px;
    border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
  
    
    &:hover {
      transform: translateY(-2px); /* Reduced from -3px for better performance */
     }
    
    h3 {
      font-size: 1.6rem;
      font-weight: 700;
      margin-bottom: 15px;
      color: ${(props) => props.theme.colors.textPrimary};
      /* text-shadow removed for TV performance */
      
      p {
        background: ${(props) => props.theme.colors.glassBackground};
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        margin: 0;
      }
    }
    
    p {
      font-size: 1.2rem;
      line-height: 1.6;
      color: ${(props) => props.theme.colors.textPrimary};
      /* text-shadow removed for TV performance */
      margin: 0;
    }
  }
  
  /* Loading State Styling */
  &.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 400px;
    
    p {
      font-size: 1.4rem;
      font-weight: 600;
      color: ${(props) => props.theme.colors.textPrimary};
      /* text-shadow removed for TV performance */
      background: ${(props) => props.theme.colors.glassBackground};
      backdrop-filter: ${(props) => props.theme.effects.backdropBlurLight}; /* Reduced for TV performance */
      /* border: ${(props) => props.theme.colors?.glassBorder || '1px solid rgba(255, 255, 255, 0.2)'}; REMOVED for TV performance */
      border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
      padding: 20px;
    }
  }
`; 